import React from 'react';
import './index.css';
import clsx from 'classnames';

const Highlight = () => {
  const lightList = [
    {
      title: '界面简洁',
      desc: '布局合理，功能模块清晰',
      img: '/img/jiemian.png',
    },
    {
      title: '人性化设计',
      desc: '视觉清晰，高效触达目标',
      img: '/img/sheji.png',
    },
    {
      title: '实时通知提醒',
      desc: '完成/到期任务系统和短信自动提醒',
      img: '/img/tip.png',
    },
    {
      title: '全景追溯',
      desc: '锚定工单节点，记录历史状态',
      img: '/img/suyuan.png',
    },
    {
      title: '权限可配置',
      desc: '细化权限结构，职级分层',
      img: '/img/kepeizhi.png',
    },
    {
      title: '业务闭环管理',
      desc: '业务/财务/商务，周期统一闭环',
      img: '/img/bihuan.png',
    },
    {
      title: '任务分派',
      desc: '点对点分派，任务流程跟踪',
      img: '/img/fenpai.png',
    },
  ];

  return (
    <div className={clsx('intelligence-highlight')}>
      <div className={clsx('intelligence-highlight-title')}>系统亮点</div>
      <div className={clsx('intelligence-highlight-content')}>
        {lightList?.map((item, index) => (
          <div
            className={clsx('intelligence-highlight-content-item')}
            key={index}
          >
            <img src={item.img} alt='' width={'20%'} height={'20%'} />
            <div className={clsx('intelligence-highlight-content-item-title')}>
              {item.title}
            </div>
            <div className={clsx('intelligence-highlight-content-item-desc')}>
              {item.desc}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Highlight;
